import React from 'react'
export default function InstallPwa({ installPromptEvent, onInstallApp }) {
    // Detect if the user is on an iOS device (iPhone, iPad, iPod).
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    const [installMessage, setInstallMessage] = React.useState(null);

    const handleInstallClick = async () => {
        if (!installPromptEvent) {
            setInstallMessage({ type: 'error', text: 'Installation is not available right now.' });
            return;
        }
        // Show the browser's installation prompt
        installPromptEvent.prompt();
        // Wait for the user to respond to the prompt
        const { outcome } = await installPromptEvent.userChoice;
        console.log(`User response to the install prompt: ${outcome}`);
        if (outcome === 'accepted') {
            setInstallMessage({ type: 'success', text: 'Thank you for installing Miners Market!' });
        } else {
            setInstallMessage({ type: 'info', text: 'Installation dismissed. You can install later from the address bar.' });
        }
        // The prompt can only be used once, so we clear it.
        onInstallApp();
    };

    // --- Conditional Rendering Logic ---

    // If the user is on iOS, show manual installation instructions.
    if (isIOS) {
        return (
            <div data-name="install-pwa-ios" data-file="components/InstallPwa.js" className="bg-gray-800/50 border border-gray-600 rounded-xl shadow-lg p-6 text-center">
                <h2 className="text-2xl font-bold text-white mb-2">Install on your iPhone/iPad</h2>
                <p className="text-gray-300 mb-4">For an app-like experience, add Miners Market to your Home Screen.</p>
                <div className="text-left text-gray-300 bg-gray-900/50 p-4 rounded-lg space-y-2">
                    <p>1. Tap the <i className="fas fa-share-square"></i> <span className="font-bold">Share</span> button in Safari.</p>
                    <p>2. Scroll down and tap <i className="fas fa-plus-square"></i> <span className="font-bold">Add to Home Screen</span>.</p>
                </div>
            </div>
        );
    }

    // For non-iOS users, only render if the install prompt event is available.
    if (!installPromptEvent) {
        return null;
    }

    return (
        <div data-name="install-pwa" data-file="components/InstallPwa.js" className="bg-gray-800/50 border border-gray-600 rounded-xl shadow-lg p-6 text-center">
            <h2 className="text-2xl font-bold text-white mb-2">Get the App Experience</h2>
            <p className="text-gray-300 mb-4">Install Miners Market on your device for faster access and an app-like experience.</p>
            {installMessage && (
                <div className={`p-3 rounded-lg text-sm mb-4 ${installMessage.type === 'error' ? 'bg-red-100 text-red-700' : installMessage.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700'}`}>
                    {installMessage.text}
                </div>
            )}
            <button onClick={handleInstallClick} className="w-full sm:w-auto primary-gradient text-white font-bold py-3 px-6 rounded-lg hover:opacity-90 transition-opacity flex items-center justify-center text-lg mx-auto">
                <i className="fas fa-download mr-3"></i> Install App
            </button>
        </div>
    );
}
